import { FC } from "react";
import ShowPatientInformation from "../addCase/showPatientInformation";
import ShowPatientAddress from "../addCase/showPatientAddress";
import ShowPrescriberInformation from "../addCase/showPrescriberInformation";
import ShowInsuranceInformation from "../addCase/showInsuranceInformation";
import { CaseStepThreeProps } from "./types";

const CaseStepThree: FC<CaseStepThreeProps> = ({ getValues }): JSX.Element => {
   const { insurances_attributes } = getValues();

  return (
    <div className="">
      <ShowPatientInformation getValues={getValues} />

      <ShowPatientAddress getValues={getValues} />

      <ShowPrescriberInformation getValues={getValues} />

      {insurances_attributes ? insurances_attributes.map((item, index) => (
        <ShowInsuranceInformation key={index} id={index+1} insurance={item} />
      )) : null}

      <p className="alert alert-warning rounded-1" role="alert">
          By signing below, I certify that (1) the above therapy is medically necessary and in the best interest of the
          patient listed above; (2) the information provided is complete and accurate to the best of my knowledge;
          (3) I have obtained any and all authorizations and consents from the patient or the patient’s authorized
          personal representative necessary under HIPAA and state law to release protected health information, including
          that contained on this form, to Pacira BioSciences and its contractors and business partners (“Contractors”)
          for purposes relating to the EXPAREL® Patient & Provider Services, to solely assist with benefits verification,
          prior authorization/appeals assistance, and forwarding the above prescription by fax or other means of delivery
          to a licensed pharmacy to dispense EXPAREL where appropriate; and [4] I agree to the Business Associate
          Agreement as presented at <a href="https://exparelsupport.com/" target="_blank" rel="noreferrer">EXPARELSupport.com</a>.
      </p>
    </div>
  );
};

export default CaseStepThree;
